/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */

import { ERR_OK, logger } from '../util/index'

let __uid = 0

export function callAndroid(fn, param, callback) {
  let id = __uid++
  let callbackName = '__bridgeCall__' + id

  let message = JSON.stringify({
    cmd: fn,
    id,
    params: param,
    callback: callbackName
  })

  window[callbackName] = function (retData) {
    let errno = retData.errno
    let err = null
    if (errno !== ERR_OK) {
      let msg = retData.errmsg
      err = { errno: retData.errno, errmsg: retData.errmsg }
    }
    // 分享面板会统一执行这个回调
    fn !== 'showEntrance' && delete window[callbackName]

    // node style
    callback(err, retData.result || retData)
  }

  logger({
    pos: 'ANDROID_SEND_MSG',
    message
  })

  window.prompt(message)
}

// export const supportPrompt = isAndroid && compareVersion('>4.2.0');



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgepassenger/android.js